import { useCustomerQuery } from '@graphcommerce/magento-customer'
import { PageMeta } from '@graphcommerce/magento-store'
import { i18n } from '@lingui/core'
import { SubUserFragment } from '../../../components/Account/SubUser/SubUser.gql'
import { SubUsers } from '../../../components/Account/SubUser/SubUsers'
import { SubUsersDocument } from '../../../components/Account/SubUser/SubUsers.gql'
import { WaitForCustomer } from '../../../components/Customer/WaitForCustomer/WaitForCustomer'

function SubUserPage() {
  const usersQuery = useCustomerQuery(SubUsersDocument, {
    fetchPolicy: 'cache-and-network',
  })
  const users = usersQuery?.data?.customer?.sub_users?.filter((user) => user)

  return (
    <div className='w-full'>
      <PageMeta title={i18n._(/* i18n */ 'Manage Users')} metaRobots={['noindex']} />
      <div className='w-full'>
        <SubUsers
          users={(users as SubUserFragment[]) || []}
          refetch={usersQuery.refetch}
          loading={usersQuery.loading}
        />
      </div>
    </div>
  )
}

export default SubUserPage
